/* eslint-disable react/jsx-wrap-multilines */
import React from "react";
import {
  FormGroup,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@material-ui/core";

export interface IconChecboxDef {
  name: string;
  label: {
    text: string;
    style: {
      enable: React.CSSProperties;
      disable: React.CSSProperties;
    };
  };
  icon: {
    node: React.ReactNode;
    style: {
      enable: React.CSSProperties;
      disable: React.CSSProperties;
    };
  };
}

export interface IconCheckboxGroupData {
  [name: string]: boolean;
}

interface Props {
  defs: Array<IconChecboxDef>;
  data: IconCheckboxGroupData;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

/** アイコンチェックボックスグループ */
export function IconChecboxGroup(props: Props) {
  const { defs, data, handleChange } = props;

  //--------------------
  // コンポーネント
  return defs.length > 0 ? (
    <FormGroup row>
      {defs.map((def: IconChecboxDef) => {
        const isChecked =
          def.name in data && typeof data[def.name] === "boolean"
            ? data[def.name]
            : false;
        return (
          <FormControlLabel
            style={{ padding: "0.25rem" }}
            key={def.name}
            control={
              <Checkbox
                key={def.name}
                checked={isChecked}
                onChange={handleChange}
                name={def.name}
                icon={def.icon.node}
                checkedIcon={def.icon.node}
                style={
                  data[def.name]
                    ? def.icon.style.enable
                    : def.icon.style.disable
                }
              />
            }
            label={
              <Typography
                component="span"
                style={
                  data[def.name]
                    ? def.label.style.enable
                    : def.label.style.disable
                }
              >
                {def.label.text}
              </Typography>
            }
          />
        );
      })}
    </FormGroup>
  ) : (
    <></>
  );
}
